module.exports = __webpack_public_path__ + "img/icon_l_jg_act.e00a32ac.png";